import React from 'react';

const Network = () => (
    <svg
        viewBox="0 0 600 760"
        preserveAspectRatio="xMidYMid slice"
        className="networkSvg"
    >
        <defs>
            {/*
                Stronger at the outside edge (x=0),
                progressively softer towards the content (x=600).
            */}
            <linearGradient id="networkFadeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="white" stopOpacity="1" />
                <stop offset="35%" stopColor="white" stopOpacity="0.9" />
                <stop offset="65%" stopColor="white" stopOpacity="0.55" />
                <stop offset="85%" stopColor="white" stopOpacity="0.22" />
                <stop offset="100%" stopColor="white" stopOpacity="0.04" />
            </linearGradient>

            <mask id="networkLinesFade">
                <rect
                    x="0"
                    y="0"
                    width="600"
                    height="760"
                    fill="url(#networkFadeGradient)"
                />
            </mask>
        </defs>

        <g mask="url(#networkLinesFade)">
            <g className="networkLines">

                {/* TOP BRANCH */}

                <line x1="0" y1="60" x2="55" y2="75" />
                <line x1="55" y1="75" x2="110" y2="90" />

                <line x1="110" y1="90" x2="155" y2="120" />
                <line x1="155" y1="120" x2="205" y2="150" />

                <line x1="205" y1="150" x2="190" y2="195" />
                <line x1="190" y1="195" x2="175" y2="245" />

                <line x1="175" y1="245" x2="235" y2="265" />
                <line x1="235" y1="265" x2="300" y2="285" />

                <line x1="300" y1="285" x2="345" y2="255" />
                <line x1="345" y1="255" x2="390" y2="230" />

                <line x1="390" y1="230" x2="430" y2="275" />
                <line x1="430" y1="275" x2="470" y2="320" />


                {/* UPPER-MIDDLE BRANCH */}

                <line x1="0" y1="180" x2="42" y2="195" />
                <line x1="42" y1="195" x2="85" y2="210" />

                <line x1="85" y1="210" x2="130" y2="228" />
                <line x1="130" y1="228" x2="175" y2="245" />

                <line x1="85" y1="210" x2="102" y2="272" />
                <line x1="102" y1="272" x2="120" y2="335" />

                <line x1="120" y1="335" x2="180" y2="352" />
                <line x1="180" y1="352" x2="245" y2="370" />

                <line x1="245" y1="370" x2="272" y2="328" />
                <line x1="272" y1="328" x2="300" y2="285" />

                <line x1="245" y1="370" x2="305" y2="390" />
                <line x1="305" y1="390" x2="365" y2="410" />

                <line x1="365" y1="410" x2="417" y2="365" />
                <line x1="417" y1="365" x2="470" y2="320" />


                {/* MIDDLE / LOWER-MIDDLE BRANCH */}

                <line x1="0" y1="430" x2="52" y2="438" />
                <line x1="52" y1="438" x2="105" y2="445" />

                <line x1="105" y1="445" x2="112" y2="390" />
                <line x1="112" y1="390" x2="120" y2="335" />

                <line x1="105" y1="445" x2="147" y2="482" />
                <line x1="147" y1="482" x2="190" y2="520" />

                <line x1="190" y1="520" x2="217" y2="445" />
                <line x1="217" y1="445" x2="245" y2="370" />

                <line x1="190" y1="520" x2="252" y2="537" />
                <line x1="252" y1="537" x2="315" y2="555" />

                <line x1="315" y1="555" x2="340" y2="482" />
                <line x1="340" y1="482" x2="365" y2="410" />


                {/* BOTTOM BRANCH */}

                <line x1="0" y1="610" x2="47" y2="597" />
                <line x1="47" y1="597" x2="95" y2="585" />

                <line x1="95" y1="585" x2="142" y2="552" />
                <line x1="142" y1="552" x2="190" y2="520" />

                <line x1="95" y1="585" x2="122" y2="642" />
                <line x1="122" y1="642" x2="150" y2="700" />

                <line x1="150" y1="700" x2="232" y2="627" />
                <line x1="232" y1="627" x2="315" y2="555" />

                <line x1="315" y1="555" x2="362" y2="602" />
                <line x1="362" y1="602" x2="410" y2="650" />


                {/* EXTRA BOTTOM STRUCTURE */}

                <line x1="0" y1="665" x2="48" y2="650" />
                <line x1="48" y1="650" x2="95" y2="585" />

                <line x1="48" y1="650" x2="92" y2="705" />
                <line x1="92" y1="705" x2="150" y2="700" />

                <line x1="0" y1="735" x2="45" y2="720" />
                <line x1="45" y1="720" x2="92" y2="705" />

                <line x1="92" y1="705" x2="135" y2="750" />
                <line x1="135" y1="750" x2="205" y2="720" />

                <line x1="150" y1="700" x2="205" y2="720" />
                <line x1="205" y1="720" x2="232" y2="627" />

                <line x1="205" y1="720" x2="275" y2="682" />
                <line x1="275" y1="682" x2="315" y2="555" />

                <line x1="275" y1="682" x2="335" y2="715" />
                <line x1="335" y1="715" x2="362" y2="602" />

                <line x1="335" y1="715" x2="395" y2="690" />
                <line x1="395" y1="690" x2="410" y2="650" />

                <line x1="395" y1="690" x2="455" y2="735" />


                {/* CROSS CONNECTIONS */}

                <line x1="110" y1="90" x2="97" y2="150" />
                <line x1="97" y1="150" x2="85" y2="210" />

                <line x1="205" y1="150" x2="252" y2="217" />
                <line x1="252" y1="217" x2="300" y2="285" />

                <line x1="175" y1="245" x2="210" y2="307" />
                <line x1="210" y1="307" x2="245" y2="370" />

                <line x1="120" y1="335" x2="155" y2="427" />
                <line x1="155" y1="427" x2="190" y2="520" />

                <line x1="245" y1="370" x2="280" y2="462" />
                <line x1="280" y1="462" x2="315" y2="555" />

                <line x1="365" y1="410" x2="387" y2="530" />
                <line x1="387" y1="530" x2="410" y2="650" />


                {/* EDGE CONNECTIONS */}

                <line x1="0" y1="300" x2="60" y2="317" />
                <line x1="60" y1="317" x2="120" y2="335" />

                <line x1="0" y1="520" x2="52" y2="482" />
                <line x1="52" y1="482" x2="105" y2="445" />

                <line x1="0" y1="720" x2="75" y2="710" />
                <line x1="75" y1="710" x2="150" y2="700" />


                {/* EXTRA INTERNAL BRANCHES */}

                <line x1="55" y1="75" x2="97" y2="150" />
                <line x1="97" y1="150" x2="155" y2="120" />

                <line x1="155" y1="120" x2="190" y2="195" />
                <line x1="190" y1="195" x2="130" y2="228" />

                <line x1="190" y1="195" x2="252" y2="217" />
                <line x1="252" y1="217" x2="235" y2="265" />

                <line x1="252" y1="217" x2="345" y2="255" />
                <line x1="345" y1="255" x2="300" y2="285" />

                <line x1="130" y1="228" x2="102" y2="272" />
                <line x1="102" y1="272" x2="175" y2="245" />

                <line x1="102" y1="272" x2="180" y2="352" />
                <line x1="180" y1="352" x2="210" y2="307" />

                <line x1="210" y1="307" x2="272" y2="328" />
                <line x1="272" y1="328" x2="235" y2="265" />

                <line x1="272" y1="328" x2="305" y2="390" />
                <line x1="305" y1="390" x2="340" y2="482" />

                <line x1="305" y1="390" x2="417" y2="365" />
                <line x1="417" y1="365" x2="365" y2="410" />

                <line x1="112" y1="390" x2="155" y2="427" />
                <line x1="155" y1="427" x2="147" y2="482" />

                <line x1="155" y1="427" x2="217" y2="445" />
                <line x1="217" y1="445" x2="252" y2="537" />

                <line x1="217" y1="445" x2="280" y2="462" />
                <line x1="280" y1="462" x2="252" y2="537" />

                <line x1="280" y1="462" x2="340" y2="482" />
                <line x1="340" y1="482" x2="315" y2="555" />

                <line x1="142" y1="552" x2="122" y2="642" />
                <line x1="142" y1="552" x2="232" y2="627" />

                <line x1="232" y1="627" x2="280" y2="462" />
                <line x1="232" y1="627" x2="362" y2="602" />
            </g>


            {/* SECONDARY CONNECTIONS */}

            <g className="networkLines networkLinesSecondary">
                <line x1="45" y1="125" x2="97" y2="150" />
                <line x1="97" y1="150" x2="175" y2="245" />

                <line x1="85" y1="210" x2="165" y2="290" />
                <line x1="165" y1="290" x2="245" y2="370" />

                <line x1="205" y1="150" x2="297" y2="190" />
                <line x1="297" y1="190" x2="390" y2="230" />

                <line x1="120" y1="335" x2="242" y2="372" />
                <line x1="242" y1="372" x2="365" y2="410" />

                <line x1="105" y1="445" x2="210" y2="500" />
                <line x1="210" y1="500" x2="315" y2="555" />

                <line x1="190" y1="520" x2="300" y2="585" />
                <line x1="300" y1="585" x2="410" y2="650" />

                {/* Bottom faint connections */}

                <line x1="48" y1="650" x2="150" y2="700" />
                <line x1="92" y1="705" x2="232" y2="627" />
                <line x1="135" y1="750" x2="275" y2="682" />
                <line x1="205" y1="720" x2="335" y2="715" />
                <line x1="275" y1="682" x2="395" y2="690" />
            </g>
        </g>


        {/* NODES */}

        <g className="networkNodes">
            <circle cx="110" cy="90" r="2.5" />
            <circle cx="205" cy="150" r="2" />

            <circle cx="175" cy="245" r="4" className="networkNodePulse" />

            <circle cx="300" cy="285" r="2.5" />
            <circle cx="390" cy="230" r="2" />

            <circle cx="85" cy="210" r="2" />
            <circle cx="120" cy="335" r="2.5" />

            <circle
                cx="245"
                cy="370"
                r="4.5"
                className="networkNodePulse networkNodeDelay"
            />

            <circle cx="365" cy="410" r="2.5" />

            <circle cx="105" cy="445" r="2" />
            <circle cx="190" cy="520" r="2.5" />

            <circle cx="315" cy="555" r="3" />

            <circle cx="95" cy="585" r="2" />
            <circle cx="150" cy="700" r="2.5" />
            <circle cx="410" cy="650" r="2" />

            <circle cx="55" cy="75" r="1.6" />
            <circle cx="155" cy="120" r="1.8" />
            <circle cx="190" cy="195" r="1.7" />

            <circle cx="235" cy="265" r="1.8" />
            <circle cx="345" cy="255" r="1.7" />
            <circle cx="430" cy="275" r="1.6" />

            <circle cx="42" cy="195" r="1.5" />
            <circle cx="130" cy="228" r="1.7" />
            <circle cx="102" cy="272" r="1.7" />

            <circle cx="180" cy="352" r="1.8" />
            <circle cx="272" cy="328" r="1.8" />
            <circle cx="305" cy="390" r="1.8" />
            <circle cx="417" cy="365" r="1.7" />

            <circle cx="52" cy="438" r="1.5" />
            <circle cx="112" cy="390" r="1.7" />
            <circle cx="147" cy="482" r="1.7" />

            <circle cx="217" cy="445" r="1.8" />
            <circle cx="252" cy="537" r="1.8" />
            <circle cx="340" cy="482" r="1.8" />

            <circle cx="47" cy="597" r="1.5" />
            <circle cx="142" cy="552" r="1.7" />
            <circle cx="122" cy="642" r="1.7" />

            <circle cx="232" cy="627" r="1.8" />
            <circle cx="362" cy="602" r="1.8" />

            <circle cx="97" cy="150" r="1.5" />
            <circle cx="252" cy="217" r="1.5" />
            <circle cx="210" cy="307" r="1.5" />
            <circle cx="155" cy="427" r="1.5" />
            <circle cx="280" cy="462" r="1.5" />
            <circle cx="387" cy="530" r="1.5" />

            {/* New lower nodes */}

            <circle cx="48" cy="650" r="1.4" />
            <circle cx="92" cy="705" r="1.6" />
            <circle cx="45" cy="720" r="1.3" />
            <circle cx="135" cy="750" r="1.4" />
            <circle cx="205" cy="720" r="1.6" />
            <circle cx="275" cy="682" r="1.7" />
            <circle cx="335" cy="715" r="1.5" />
            <circle cx="395" cy="690" r="1.5" />
        </g>


        {/* DATA PARTICLES */}

        <g className="networkParticles">
            <circle cx="35" cy="95" r="0.8" />
            <circle cx="75" cy="130" r="0.8" />
            <circle cx="135" cy="75" r="0.8" />
            <circle cx="175" cy="105" r="0.8" />
            <circle cx="235" cy="175" r="0.8" />
            <circle cx="285" cy="145" r="0.8" />
            <circle cx="330" cy="180" r="0.8" />
            <circle cx="370" cy="150" r="0.8" />

            <circle cx="40" cy="245" r="0.8" />
            <circle cx="70" cy="285" r="0.8" />
            <circle cx="145" cy="275" r="0.8" />
            <circle cx="205" cy="315" r="0.8" />
            <circle cx="260" cy="300" r="0.8" />
            <circle cx="335" cy="335" r="0.8" />
            <circle cx="385" cy="300" r="0.8" />
            <circle cx="430" cy="285" r="0.8" />

            <circle cx="35" cy="390" r="0.8" />
            <circle cx="75" cy="405" r="0.8" />
            <circle cx="135" cy="385" r="0.8" />
            <circle cx="180" cy="420" r="0.8" />
            <circle cx="230" cy="400" r="0.8" />
            <circle cx="290" cy="450" r="0.8" />
            <circle cx="335" cy="430" r="0.8" />
            <circle cx="405" cy="470" r="0.8" />

            <circle cx="35" cy="545" r="0.8" />
            <circle cx="80" cy="525" r="0.8" />
            <circle cx="125" cy="560" r="0.8" />
            <circle cx="170" cy="545" r="0.8" />
            <circle cx="215" cy="580" r="0.8" />
            <circle cx="260" cy="600" r="0.8" />
            <circle cx="310" cy="590" r="0.8" />
            <circle cx="360" cy="610" r="0.8" />

            <circle cx="45" cy="675" r="0.8" />
            <circle cx="80" cy="695" r="0.8" />
            <circle cx="115" cy="665" r="0.8" />
            <circle cx="180" cy="675" r="0.8" />
            <circle cx="230" cy="680" r="0.8" />
            <circle cx="280" cy="650" r="0.8" />
            <circle cx="335" cy="690" r="0.8" />
            <circle cx="385" cy="675" r="0.8" />

            <circle cx="24" cy="42" r="0.55" />
            <circle cx="98" cy="48" r="0.65" />
            <circle cx="188" cy="42" r="0.55" />
            <circle cx="278" cy="52" r="0.65" />
            <circle cx="374" cy="68" r="0.5" />
            <circle cx="458" cy="52" r="0.65" />

            <circle cx="38" cy="155" r="0.4" />
            <circle cx="168" cy="198" r="0.5" />
            <circle cx="266" cy="218" r="0.65" />
            <circle cx="414" cy="178" r="0.6" />

            <circle cx="18" cy="264" r="0.6" />
            <circle cx="148" cy="322" r="0.4" />
            <circle cx="238" cy="338" r="0.4" />
            <circle cx="382" cy="292" r="0.6" />

            <circle cx="32" cy="378" r="0.4" />
            <circle cx="168" cy="432" r="0.65" />
            <circle cx="264" cy="444" r="0.5" />
            <circle cx="452" cy="448" r="0.55" />

            <circle cx="18" cy="492" r="0.5" />
            <circle cx="108" cy="498" r="0.65" />
            <circle cx="292" cy="518" r="0.6" />
            <circle cx="470" cy="506" r="0.65" />

            <circle cx="34" cy="612" r="0.4" />
            <circle cx="82" cy="646" r="0.6" />
            <circle cx="174" cy="662" r="0.5" />
            <circle cx="268" cy="684" r="0.65" />
            <circle cx="408" cy="646" r="0.4" />

            <circle cx="46" cy="734" r="0.4" />
            <circle cx="116" cy="716" r="0.5" />
            <circle cx="204" cy="738" r="0.4" />
            <circle cx="294" cy="714" r="0.6" />
            <circle cx="378" cy="736" r="0.4" />
            <circle cx="448" cy="718" r="0.5" />
        </g>


        {/* BRIGHTER STARS */}

        <g className="spaceStars">
            <circle cx="68" cy="138" r="1.2" />
            <circle cx="258" cy="118" r="1" />
            <circle cx="420" cy="246" r="1.25" />

            <circle cx="72" cy="352" r="1" />
            <circle cx="328" cy="372" r="1.2" />
            <circle cx="450" cy="438" r="1" />

            <circle cx="126" cy="574" r="1.25" />
            <circle cx="286" cy="604" r="1" />
            <circle cx="410" cy="672" r="1.2" />
        </g>


        {/* GLOWING STARS */}

        <g className="spaceGlowStars">
            <circle cx="52" cy="248" r="1.4" />
            <circle cx="348" cy="154" r="1.2" />
            <circle cx="396" cy="486" r="1.4" />
            <circle cx="92" cy="658" r="1.2" />
        </g>

    </svg>
);


const NetworkBackground = () => (
    <div>
        <div className="networkBackground networkBackgroundLeft">
            <Network />
        </div>

        <div className="networkBackground networkBackgroundRight">
            <Network />
        </div>
    </div>
);

export default NetworkBackground;



// WEBPACK FOOTER //
// ./src/components/NetworkBackground.js